<div class="state-context">
  <ng-template addHost></ng-template>
</div>
